import { IRegistrationKiwiSaverEntityState, IRegistrationKiwiSaverStatusState } from './../../state/registration-kiwisaver.state';
import { Action } from '@ngrx/store';
import { RegistrationKiwiSaverEntityReducer } from './registration-kiwisaver-entity.reducer';
import { RegistrationKiwiSaverStatusReducer } from './registration-kiwisaver-status.reducer';

export type Reducer<T> = (state: T, action: Action) => T;


export interface IRegistrationKiwiSaverState {
    kiwiSaverEntity: Reducer<IRegistrationKiwiSaverEntityState>;
    kiwiSaverStatus: Reducer<IRegistrationKiwiSaverStatusState>;
}

export const RegistrationKiwiSaverReducers: IRegistrationKiwiSaverState = {
    kiwiSaverEntity: RegistrationKiwiSaverEntityReducer,
    kiwiSaverStatus: RegistrationKiwiSaverStatusReducer
};
